import React, { Fragment } from "react";
import { ChampionIcon } from "../../assets/icons";
import {
  AdaptiveImage,
  StyledFindOpponent,
  StyledNetworkShop,
  StyledOpponentsList,
  StyledIntroduceSection,
  StyledIntroduceContent
} from "./ui";
import SliderSimple from "../../components/SwipeSlider";

const FindOpponent = () => {
  return (
    <Fragment>
      <StyledIntroduceSection>
        <StyledIntroduceContent>
          <ChampionIcon />
          <p>Opponents, Leagues and Tournaments </p>
          <h3>Play opponents on your level</h3>
          <AdaptiveImage />
        </StyledIntroduceContent>
      </StyledIntroduceSection>

      <StyledFindOpponent>
        <h3>Exsportia’s Find Opponent®</h3>
        <StyledOpponentsList>
          <p>A revolution in amateur sports. Play opponents on your level.</p>
          <p>Join Teams, Create / manage tournaments and leagues.</p>
          <p>Get your ranking and your sports lifestyle started.</p>
        </StyledOpponentsList>
        <StyledNetworkShop>
          <img src="./images/apple-store.png" alt="" />
          <img src="./images/google-play.png" alt="" />
        </StyledNetworkShop>
      </StyledFindOpponent>

      <SliderSimple />
    </Fragment>
  );
};

export default FindOpponent;
